import { Work } from '@/core/models/Work'
import { GetterTree } from 'vuex'
import { IRootState } from '@/store/'
import { IWorkspaceState } from './index'

export const getters: GetterTree<IWorkspaceState, IRootState> = {}
